import React from 'react';
import OldAdAccount from '../../../../configure/panels/sections/AdvertisingSettingsSection/AdAccount/AdAccount';

export const AdAccount = () => {
  return <OldAdAccount />;
};
